import SectionTitle from './SectionTitle'
export default SectionTitle
export * from './types'
